import type { Modal } from "@circleco/compass/components/Modal";
import type { ComponentPropsWithoutRef } from "react";

import { ImageEditorModalWithCropComponent } from "./ImageEditorModalWithCropComponent";

export interface ImageEditorModalWithCropProps {
  aspectRatio?: number;
  attachImage?: ((itemUrl: string, signedId: string) => void) | null;
  closeModal: () => void;
  customAspectRatioHelpText?: string | null;
  formClass?: string;
  hasFile?: boolean;
  hideEmbedUrl?: boolean;
  hideUnsplash?: boolean;
  initialFile?: File | null;
  inputFieldName?: string;
  isCropEnabled?: boolean;
  isPublic?: boolean;
  saveImage?: ((signedId: string) => void) | null;
  setHasFile: (hasFile: boolean) => void;
  setIsLoading?: (isLoading: boolean) => void;
  showModal?: boolean;
  size?: ComponentPropsWithoutRef<typeof Modal.Root>["size"];
  title?: string;
  uploadProgress: (progress: number, fileName: string) => void;
}

export const ImageEditorModalWithCrop = ImageEditorModalWithCropComponent;
